import { atom } from "jotai";

export const dashboardCardsData = atom([]);
